import { defineMessages } from 'react-intl';

export default defineMessages({
  return : {
    id: 'sublocation.mapping.return.title',
    defaultMessage: 'Return'
  },
  layby : {
    id: 'sublocation.mapping.layby.title',
    defaultMessage: 'LayBy'
  },
  deposit : {
    id: 'sublocation.mapping.deposit.title',
    defaultMessage: 'Deposit'
  },
  disposal : {
    id: 'sublocation.mapping.disposal.title',
    defaultMessage: 'Disposal'
  },
  shipping : {
    id: 'sublocation.mapping.shipping.title',
    defaultMessage: 'Shipping'
  },
  pickup : {
    id: 'sublocation.mapping.pickup.title',
    defaultMessage: 'Pick-Up'
  },
  preorder : {
    id: 'sublocation.mapping.preorder.title',
    defaultMessage: 'Preorder'
  },
  reserved : {
    id: 'sublocation.mapping.reserved.title',
    defaultMessage: 'Reserved'
  }
});
